import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { HttpFilter } from 'sol-request-angular/dist/comunicacao';
import { Equal } from 'sol-request-angular/dist/comunicacao/filter/Equal';

export class CidadeSearch{
    idIbge: number;
    nmCidade: string;
    cdEstado: number;
    nmEstado: string;
    limit: number;
    page: number;

    constructor(data:{idIbge?:number, nmCidade?:string, cdEstado?:number, nmEstado?:string, limit?:number, page?: number}){
        this.idIbge = data && data.idIbge;
        this.nmCidade = data && data.nmCidade;
        this.nmEstado = data && data.nmEstado;
        this.cdEstado = data && data.cdEstado;
        this.limit = data && data.limit;
        this.page = data && data.page;
    }

    getFilters():IFilter{
        let filtros:IFilter = new HttpFilter([
            new Equal('limit', 50)
        ]);

        if(this.idIbge){
            filtros.addFilter(new Equal('ibge', this.idIbge));
            this.limit = 100;
        }

        if(this.nmCidade){
            filtros.addFilter(new Equal('cidade', this.nmCidade));
            this.limit = 100;
        }            

        if(this.nmEstado){
            filtros.addFilter(new Equal('estado', this.nmEstado));
            this.limit = 100;
        }            
       
        if(this.cdEstado){
            filtros.addFilter(new Equal('estado', this.cdEstado));
            this.limit = 100;
        }            
        
        if(this.limit){
            filtros.addFilter(new Equal('limit', this.limit));
            this.limit = 100;
        }            
        
        if(this.page){
            filtros.addFilter(new Equal('page', this.page));
            this.limit = 100;
        }            

        return filtros;
    }
}
